// Virtual Marketer Primeo - API Service
// Version: 1.0.0

import { ChatRequest, ChatResponse, OrderInfo, ChatMessage } from '../types';
import { API_BASE_URL } from '../constants';

/**
 * Send a chat message to the backend API
 */
export async function sendChatMessage(
    message: string,
    sessionId: string,
    history?: ChatMessage[],
    swissGerman?: boolean
): Promise<ChatResponse> {
    const response = await fetch(`${API_BASE_URL}/chat/message`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message,
            sessionId,
            history,
            swissGerman
        })
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({ error: 'Network error' }));
        throw new Error(error.error || 'Failed to send message');
    }

    return response.json();
}

/**
 * Get order by ID
 */
export async function getOrder(orderId: string): Promise<OrderInfo> {
    const response = await fetch(`${API_BASE_URL}/orders/${orderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch order');
    }

    const data = await response.json();
    return data.data;
}

/**
 * Track order by email and order number
 */
export async function trackOrder(email: string, orderNumber: string): Promise<OrderInfo> {
    const response = await fetch(`${API_BASE_URL}/orders/track`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email,
            orderNumber
        })
    });

    if (!response.ok) {
        throw new Error('Failed to track order');
    }

    const data = await response.json();
    return data.data;
}

/**
 * Check API health
 */
export async function checkHealth(): Promise<boolean> {
    try {
        const response = await fetch(`${API_BASE_URL.replace('/api/v1', '')}/health`);
        return response.ok;
    } catch {
        return false;
    }
}
